import config from '@/assets/js/config/Config'

import Luts from '@/assets/js/Luts';
import GPU from '@/assets/js/GPU';
import AppUI from '@/assets/js/UI';
import Lutify from '@/assets/js/Lutify';
import Blocks from '@/assets/js/Blocks';
import LutsPreview from "@/assets/js/LutsPreview";
import FileLoader from "@/assets/js/FileLoader";
import Scopes from "@/assets/js/Scopes";
import Histogram from "@/assets/js/Histogram";

import HSLcontrol from "@/assets/js/blocks/hsl";
import SkinToneEditor from "@/assets/js/blocks/SkinToneEditor";
import Contrast from "@/assets/js/blocks/Contrast";
import ContrastV2 from '@/assets/js/blocks/ContrastV2'
import Exposure from "@/assets/js/blocks/Exposure";
import ExposureV2 from "@/assets/js/blocks/ExposureV2";
import HueSaturation from "@/assets/js/blocks/hueSaturation";
import WhiteBalance from "@/assets/js/blocks/whiteBalance";
import ShadowHighlightsRecovery from "@/assets/js/blocks/shadowHighlightsRecovery";
import LUTcontrol from "@/assets/js/blocks/LUTcontrol";
import SmartWarmth from "@/assets/js/blocks/smartWarmth";
import Technicolor3StripProcess from "@/assets/js/blocks/technicolor3StripProcess";
import TealAndOrange from "@/assets/js/blocks/tealAndOrange";
import SmartCurves from "@/assets/js/blocks/curve";
import Primaries from "@/assets/js/blocks/Primaries";
import PrimariesV2 from "@/assets/js/blocks/PrimariesV2";
import LogPrimaries from "@/assets/js/blocks/logPrimaries";
import PrinterLights from "@/assets/js/blocks/PrinterLights";
import PrinterLightsV2 from "@/assets/js/blocks/PrinterLightsV2";
import BlackAndWhite from "@/assets/js/blocks/blackAndWhite";
import CustomLUT from "@/assets/js/blocks/customLUT";
import CustomLutV2 from "@/assets/js/blocks/CustomLutV2";
import MagicMode from "@/assets/js/blocks/magicMode";
import MidtoneTexture from "@/assets/js/blocks/MidtoneTexture";
import ColourDensity from "@/assets/js/blocks/ColourDensity";
import SubtractiveColour from "@/assets/js/blocks/SubtractiveColour";
import ColourMatch from "@/components/app/blocks/ColourMatch/V1/ColourMatch";
import ColourMatchV2 from "@/components/app/blocks/ColourMatch/V2/ColourMatchV2";
import AdvancedColourMatchV2 from "@/components/app/blocks/ColourMatch/V2/AdvancedColourMatchV2";
import LMT from "@/components/app/blocks/LMT/LMT";
import AIColourExtract from "@/components/app/blocks/AIColourExtract/V1/AIColourExtract";
import AIColourExtractV2 from "@/components/app/blocks/AIColourExtract/V2/AIColourExtract";
import AIAutoCorrect from "@/assets/js/blocks/AIAutoCorrect";
import AIAutoCorrectV2 from "@/assets/js/blocks/AIAutoCorrectV2";
import NeuralToneAI from "@/assets/js/blocks/NeuralToneAI";
import NeuralFilmAI from "@/assets/js/blocks/NeuralFilmAI";
import AIColourMatch from "@/components/app/blocks/AIColourMatch/V1/AIColourMatch";
import AIColourMatchV2 from "@/components/app/blocks/AIColourMatch/V2/AIColourMatchV2";
import GamutCompress from "@/assets/js/blocks/GamutCompress";
import AIMagicMode from "@/assets/js/blocks/AIMagicMode";
import Vibrance from "@/assets/js/blocks/Vibrance";
// import LensDistortionEffect from "@/assets/js/blocks/LensDistortionEffect";
import TetrahedralInterpolation from "@/assets/js/blocks/TetrahedralInterpolation";
import {
	blocksStore,
	candidatesStore,
	defaultsStore,
	imagesStateStore,
	imagesStore,
	INDEXED_DB_VERSION_LUT_CONTROLS,
	INDEXED_DB_VERSION_LUT_SLIDERS,
	INDEXED_DB_VERSION_SYSTEM_LUTS,
	layoutsStore,
	customLutsStore,
	LUTcontrolsStore,
	LUTslidersStore,
	matchesStore,
	presetsStore,
	projectsThumbnailsStore,
	systemLutsStore,
	thumbnailsStore,
	uploadCandidatesStore,
	uploadImagesStore,
	uploadMatchesStore,
	versionStore
} from "@/services/indexedDB.service";
import AIExposure from "@/assets/js/blocks/AIExposure";
import AIContrast from "@/assets/js/blocks/AIContrast";
import AIWhiteBalance from "@/assets/js/blocks/AIWhiteBalance";

// IDB SERVICE
window.versionStore = versionStore;
window.LUTcontrolsStore = LUTcontrolsStore;
window.LUTslidersStore = LUTslidersStore;
window.systemLutsStore = systemLutsStore;
window.imagesStore = imagesStore;
window.uploadImagesStore = uploadImagesStore;
window.thumbnailsStore = thumbnailsStore;
window.matchesStore = matchesStore;
window.candidatesStore = candidatesStore;
window.uploadCandidatesStore = uploadCandidatesStore;
window.uploadMatchesStore = uploadMatchesStore;
window.imagesStateStore = imagesStateStore;
window.layoutsStore = layoutsStore;
window.customLutsStore = customLutsStore;
window.presetsStore = presetsStore;
window.blocksStore = blocksStore;
window.projectsThumbnailsStore = projectsThumbnailsStore;
window.defaultsStore = defaultsStore;

// Create IDB instances
window.versionStore.createInstance();
window.imagesStore.createInstance();
window.uploadImagesStore.createInstance();
window.thumbnailsStore.createInstance();
window.matchesStore.createInstance();
window.candidatesStore.createInstance();
window.uploadCandidatesStore.createInstance();
window.uploadMatchesStore.createInstance();
window.imagesStateStore.createInstance();
window.layoutsStore.createInstance();
window.presetsStore.createInstance();
window.blocksStore.createInstance();
window.projectsThumbnailsStore.createInstance();
window.defaultsStore.createInstance();

LUTcontrolsStore.createInstance().ready(async () => {
	let version = await versionStore.getItem('LUTControls');
	if (!version || version < INDEXED_DB_VERSION_LUT_CONTROLS) {
		LUTcontrolsStore.clear();
		versionStore.setItem('LUTControls', INDEXED_DB_VERSION_LUT_CONTROLS);
	}
})

LUTslidersStore.createInstance().ready(async () => {
	let version = await versionStore.getItem('LUTSliders');
	if (!version || version < INDEXED_DB_VERSION_LUT_SLIDERS) {
		LUTslidersStore.clear();
		versionStore.setItem('LUTSliders', INDEXED_DB_VERSION_LUT_SLIDERS);
	}
})

systemLutsStore.createInstance().ready(async () => {
	let version = await versionStore.getItem('SystemLUTs');
	if (!version || version < INDEXED_DB_VERSION_SYSTEM_LUTS) {
		systemLutsStore.clear();
		versionStore.setItem('SystemLUTs', INDEXED_DB_VERSION_SYSTEM_LUTS);
	}
})


// CORE SERVICES
var UI, gpu, luts, lutify, blocks, lutPreviewer, loader, _Adjustments, scopes, histogram;

gpu = new GPU();
UI = new AppUI();
luts = new Luts();
lutify = new Lutify();
blocks = new Blocks();
lutPreviewer = new LutsPreview();
loader = new FileLoader();
scopes = new Scopes();
histogram = new Histogram();
_Adjustments = {
	HSL: new HSLcontrol(),
	SkinToneEditor: new SkinToneEditor(),
	contrast: new Contrast(),
	ContrastV2: new ContrastV2(),
	exposure: new Exposure(),
	ExposureV2: new ExposureV2(),
	hueSaturation: new HueSaturation(),
	whiteBalance: new WhiteBalance(),
	shadowHighlightsRecovery: new ShadowHighlightsRecovery(),
	LUTcontrols: new LUTcontrol(),
	smartWarmth: new SmartWarmth(),
	technicolor3StripProcess: new Technicolor3StripProcess(),
	tealAndOrange: new TealAndOrange(),
	smartCurves: new SmartCurves(),
	primaries: new Primaries(),
	PrimariesV2: new PrimariesV2(),
	logPrimaries: new LogPrimaries(),
	printerLights: new PrinterLights(),
	PrinterLightsV2: new PrinterLightsV2(),
	// shadowTint: new ShadowTint(),
	// highlightTint: new HighlightTint(),
	blackAndWhite: new BlackAndWhite(),
	customLUT: new CustomLUT(),
	CustomLutV2: new CustomLutV2(),
	magicMode: new MagicMode(config.magicModeBlocks),
	midtoneTexture: new MidtoneTexture(),
	colourDensity: new ColourDensity(),
	subtractiveColour: new SubtractiveColour(),
	colourMatch: new ColourMatch(),
	ColourMatchV2: new ColourMatchV2(),
	AdvancedColourMatchV2: new AdvancedColourMatchV2(),
	AIColourExtract: new AIColourExtract(),
	AIColourExtractV2: new AIColourExtractV2(),
	AIAutoCorrect: new AIAutoCorrect(),
	AIAutoCorrectV2: new AIAutoCorrectV2(),
	NeuralToneAI: new NeuralToneAI(),
	NeuralFilmAI: new NeuralFilmAI(),
	AIColourMatch: new AIColourMatch(),
	AIColourMatchV2: new AIColourMatchV2(),
	LMT: new LMT(),
	GamutCompress: new GamutCompress(),
	AIMagicMode: new AIMagicMode(config.AIMagicModeBlocks),
	AIExposure: new AIExposure(),
	AIContrast: new AIContrast(),
	AIWhiteBalance: new AIWhiteBalance(),
	Vibrance: new Vibrance(),
	// LensDistortionEffect: new LensDistortionEffect(),
	TetrahedralInterpolation: new TetrahedralInterpolation()
};

window.UI = UI;
window.gpu = gpu;
window.luts = luts;
window.lutify = lutify;
window.blocks = blocks;
window.lutPreviewer = lutPreviewer;
window.loader = loader;
window.lutPreviewer = lutPreviewer;
window.scopes = scopes;
window.histogram = histogram;
window._Adjustments = _Adjustments;

// Starting the app...
luts.fetchAll();
UI.initEvents();

export { UI, lutify, gpu, luts, blocks };


